import { useEffect } from "react";

import styles from "styles/pages/reports/reports.module.scss";

import * as echarts from "echarts";

const categories = (data = {}) => {
  return [
    {
      alias: "Usos",
      name: "Usos",
      color: "#5441BE",
      total: data.uses,
    },
    {
      alias: "Expirações",
      name: "Expirações",
      color: "#C55461",
      total: data.expired,
    },
  ];
};


export default function UsesAndExpiration({ data }) {
  const toPercent = (value) => `${(value * 100).toFixed(2)}%`;

  useEffect(() => {
    if (typeof window !== "undefined") {
      const chartDOM = document.getElementById("uses-expiration-chart");
      const chart = echarts.init(chartDOM, null, {
        renderer: "svg",
      });

      const getData = () => {
        return categories(data).map((category) => ({
          value: category.total,
          name: category.name,
          itemStyle: {
            color: category.color || "#fff",
          },
        }));
      };

      const options = {
        tooltip: {
          trigger: "item",
          responsive: true,
          formatter: (param) => {
            const data = param.data;
            return [
              `<span>${
                data.name
              }</span><br/><span style="opacity: 50%">${toPercent(
                data.value
              )}</span>`,
            ].join("");
          },
          backgroundColor: "#242424",
          borderWidth: "0",
          borderColor: "transparent",
          textStyle: {
            color: "#fff",
            fontSize: 10,
          },
        },
        series: [
          {
            type: "pie",
            radius: ["85%"],
            center: ["50%", "45%"],
            label: {
              show: false,
              position: "center",
            },
            data: getData(),
          },
        ],
        legend: {
          top: "bottom",
          marginBottom: 20,
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 10,
          textStyle: {
            color: "#808080",
            fontSize: 12,
          },
        },
      };

      options && chart.setOption(options);

      const ro = new ResizeObserver(() => {
        chart.resize();
      });
      ro.observe(chartDOM);

      return () => {
        ro.unobserve(chartDOM);
        ro.disconnect();
        chart.dispose();
      };
    }
  }, [data]);

  return (
    <div className={styles.box}>
      <div className="d-flex align-center justify-between">
        <div className="d-flex align-center gap-5">
          <p className={styles.label}>
            Proporção entre usos e expiração de cupom
          </p>
        </div>
      </div>

      <div className={styles.hairline} />

      <div className={styles.container}>
        <div
          id="uses-expiration-chart"
          style={{
            width: "100%",
            height: "100%",
            minHeight: 350,
            margin: "auto",
          }}
        />
      </div>
    </div>
  );
}
